module.exports = __webpack_public_path__ + "img/barnard_3.713d36a0.jpg";